module.exports = __webpack_public_path__ + "media/images/content-ad709e1d.jpg";